import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
import { TIMELINE_PICTURE_SLOT } from "../timeline";
export const timelineSchema = {
    componentId: "Timeline",
    scalarSlots: [
        { key: "eyebrow", label: "Eyebrow", type: "text" },
        {
            key: "timelineTitle",
            ...TITLE_COPY_LIMITS,
            label: "Timeline title",
            type: "text",
            defaultValue: "Our Story",
        },
        {
            key: "sortDirection",
            label: "Year order",
            type: "select",
            options: [
                { value: "asc", label: "Oldest first" },
                { value: "desc", label: "Newest first" },
            ],
        },
    ],
    mediaSlots: [],
    repeatSlots: [
        {
            key: "milestones",
            label: "Years",
            itemLabel: "Year",
            sortBy: "year",
            sortDirectionField: "sortDirection",
            uniqueBy: "year",
            minItems: 1,
            scalarSlots: [
                { key: "year", label: "Year", type: "text" },
                {
                    key: "titleTop",
                    ...TITLE_COPY_LIMITS,
                    label: "Title top",
                    type: "text",
                },
                {
                    key: "titleBottom",
                    ...TITLE_COPY_LIMITS,
                    label: "Title bottom",
                    type: "text",
                },
                {
                    key: "descriptionHeader",
                    ...TITLE_COPY_LIMITS,
                    label: "Description header",
                    type: "text",
                },
                {
                    key: "description",
                    ...DESCRIPTION_COPY_LIMITS,
                    label: "Description",
                    type: "textarea",
                },
            ],
            // Built from the one declaration in `../timeline`, so the size the picker
            // enforces and the size a stored reference is named by cannot drift.
            mediaSlots: [
                TIMELINE_PICTURE_SLOT,
                // Generated automatically for the timeline cover, not an author field.
                {
                    key: "thumbnail",
                    label: "Timeline thumbnail",
                    unframed: true,
                    targets: [],
                },
            ],
        },
        {
            key: "groups",
            label: "Milestone groups",
            itemLabel: "Milestone group",
            scalarSlots: [
                { key: "yearId", label: "Year", type: "text" },
                {
                    key: "descriptionHeader",
                    ...TITLE_COPY_LIMITS,
                    label: "Title",
                    type: "text",
                },
                {
                    key: "description",
                    ...DESCRIPTION_COPY_LIMITS,
                    label: "Description",
                    type: "textarea",
                },
            ],
            mediaSlots: [],
        },
        {
            key: "gallery",
            label: "Gallery",
            itemLabel: "Image",
            scalarSlots: [
                { key: "groupId", label: "Milestone group", type: "text" },
                { key: "alt", label: "Alternative text", type: "text" },
            ],
            mediaSlots: [
                { key: "image", label: "Image", unframed: true, targets: [] },
                {
                    key: "thumbnail",
                    label: "Timeline thumbnail",
                    unframed: true,
                    targets: [],
                },
            ],
        },
    ],
};
//# sourceMappingURL=timeline.js.map